var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['menu-pc',{'w260':_vm.lang=='en'},{'w280':_vm.lang=='de'}]},[_c('transition',{attrs:{"name":"slide-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isCollapse),expression:"!isCollapse"}],staticClass:"show-menu"},[_c('menu-list',{attrs:{"isActive":_vm.isActive}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }